import { FC, PropsWithChildren } from 'react';

export interface ShowableProps extends PropsWithChildren {
	show?: unknown;
	hide?: unknown;
}

/**
 * @deprecated Has been moved to shared library
 */
const Showable: FC<ShowableProps> = ({ children, ...rest }) => {
	if (getIsShown(rest)) {
		return <>{children}</>;
	}

	return <></>;
};

function getIsShown({ show = false, ...rest }: { show?: unknown; hide?: unknown }): boolean {
	if ('hide' in rest) {
		show = !rest.hide;
	}

	return !!show;
}

export default Showable;
